import { render, staticRenderFns } from "./TypeSelect.vue?vue&type=template&id=3b9fb7d0"
import script from "./TypeSelect.vue?vue&type=script&lang=js"
export * from "./TypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports